import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router';
import styles from './Login.module.css';

const API = import.meta.env.VITE_API_URL || '/api';

export function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('パスワードは8文字以上で設定してください');
      return;
    }
    if (password !== confirmPassword) {
      setError('パスワードが一致しません');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'パスワードの更新に失敗しました');
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'パスワードの更新に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className={styles.page}>
        <div className={styles.card}>
          <div className={styles.logo}>
            <div className={styles.logoIcon}>ME</div>
            <div className={styles.logoText}>住縁 Mirai EMS</div>
          </div>
          <div className={styles.subtitle}>パスワードリセット</div>
          <div className={styles.error}>無効なリセットリンクです</div>
          <Link to="/forgot-password" style={{ display: 'block', fontSize: 12, color: 'var(--brand)', textAlign: 'center', marginTop: 16 }}>
            パスワードリセットを再申請する
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <div className={styles.logoIcon}>ME</div>
          <div className={styles.logoText}>住縁 Mirai EMS</div>
        </div>
        <div className={styles.subtitle}>新しいパスワードを設定</div>

        {done ? (
          <>
            <p style={{ fontSize: 13, color: 'var(--ink2)', lineHeight: 1.7, marginBottom: 20 }}>
              パスワードが更新されました。<br />
              新しいパスワードでログインしてください。
            </p>
            <Link to="/login" className={styles.btn} style={{ display: 'block', textDecoration: 'none', textAlign: 'center' }}>
              ログイン画面へ
            </Link>
          </>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.field}>
              <label className={styles.label}>新しいパスワード</label>
              <input className={styles.input} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} autoFocus />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>パスワード確認</label>
              <input className={styles.input} type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required minLength={8} />
            </div>
            {error && <div className={styles.error}>{error}</div>}
            <button className={styles.btn} type="submit" disabled={loading}>
              {loading ? '更新中...' : 'パスワードを更新'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
